if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');

        this.elements = {
          countryInput: this.querySelector('input[name="country_code"]'),
          localeInput: this.querySelector('input[name="locale_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));

        if (this.elements.button) {
          this.elements.button.addEventListener('click', this.openSelector.bind(this));
        }

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }

        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }

        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => {
          item.addEventListener('click', this.onItemClick.bind(this));
        });
      }

      hidePanel() {
        if (this.elements.button) {
          this.elements.button.setAttribute('aria-expanded', 'false');
        }

        if (this.elements.panel) {
          this.elements.panel.setAttribute('hidden', true);
        }

        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }

        const insideLocalizationModal = !!this.closest('.custom-dialog-container');

        if (!insideLocalizationModal) {
          document.body.classList.remove('overflow-hidden-mobile');

          const drawer = document.querySelector('.menu-drawer');
          if (drawer) drawer.classList.remove('country-selector-open');

          if (this.header) this.header.preventHide = false;
        }
      }

      openSelector(event) {
        if (event) event.preventDefault();
        if (!this.elements.button || !this.elements.panel) return;

        const insideLocalizationModal = !!this.closest('.custom-dialog-container');

        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');

        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );

        if (!insideLocalizationModal) {
          if (!document.body.classList.contains('overflow-hidden-tablet')) {
            document.body.classList.add('overflow-hidden-mobile');
          }

          if (this.hasAttribute('data-prevent-hide') && this.header) {
            this.header.preventHide = true;
          }

          const drawer = document.querySelector('.menu-drawer');
          if (drawer) drawer.classList.add('country-selector-open');
        }
      }

      closeSelector(event) {
        if (!this.elements.button || !this.elements.panel) return;
        if (!event.relatedTarget) return;

        if (
          event.target.classList?.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );

        if (!focusableItems.length) return;

        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;

          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id || '');
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        if (!this.elements.button) return;

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            event.preventDefault();
            if (this.elements.button.getAttribute('aria-expanded') === 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;

          case 'SPACE':
            if (event.target === this.elements.search) return;
            event.preventDefault();
            if (this.elements.button.getAttribute('aria-expanded') === 'true') return;
            this.openSelector();
            break;
        }
      }

      async onItemClick(event) {
        event.preventDefault();

        const form = this.closest('form');
        if (!form) return;

        const value = event.currentTarget.dataset.value;
        const isCountry = !!event.currentTarget.closest('ul.countries, ul.popular-countries');
        const applyBtn = form.querySelector('[data-localization-apply]');

        const markSelected = () => {
          this.querySelectorAll('a.disclosure__link[aria-current="true"]').forEach((a) => {
            a.removeAttribute('aria-current');
          });
          event.currentTarget.setAttribute('aria-current', 'true');
        };

        const updateCountryButtonUI = () => {
          const btnName = this.querySelector('.disclosure__button .disclosure__country-name');
          const newName = event.currentTarget.querySelector('.country')?.textContent?.trim();
          if (btnName && newName) btnName.textContent = newName;

          const btnIconWrap = this.querySelector('.disclosure__button .disclosure__country-icon');
          const clickedIconImg = event.currentTarget.querySelector('.disclosure__country-icon img');

          if (btnIconWrap && clickedIconImg) {
            const currentBtnImg = btnIconWrap.querySelector('img');
            if (currentBtnImg) {
              currentBtnImg.src = clickedIconImg.src;
              currentBtnImg.srcset = clickedIconImg.srcset || '';
            } else {
              btnIconWrap.innerHTML = clickedIconImg.outerHTML;
            }
          }
        };

        const updateLanguageButtonUI = () => {
          const btnName = this.querySelector('.disclosure__button .disclosure__language-name');
          const newName =
            event.currentTarget.querySelector('span:last-child')?.textContent?.trim() ||
            event.currentTarget.textContent?.trim();

          if (btnName && newName) btnName.textContent = newName;
        };

        if (isCountry) {
          const formCountry = form.querySelector('input[name="country_code"]');
          if (formCountry) formCountry.value = value;

          markSelected();
          updateCountryButtonUI();

          const container = form.querySelector('#MarketSwitcherLanguageContainer');
          const groups = container ? container.querySelectorAll('.market-language-group') : [];

          groups.forEach((group) => {
            group.hidden = group.getAttribute('data-country') !== value;
          });

          const activeGroup = container?.querySelector(`.market-language-group[data-country="${value}"]`);
          const masterLocaleInput = form.querySelector('input[name="locale_code"]');

          if (activeGroup) {
            const selectedLanguageLink =
              activeGroup.querySelector('a.disclosure__link[aria-current="true"]') ||
              activeGroup.querySelector('a.disclosure__link[data-value]');

            if (masterLocaleInput && selectedLanguageLink?.dataset.value) {
              masterLocaleInput.value = selectedLanguageLink.dataset.value;
            }
          } else if (masterLocaleInput) {
            // US fallback
            masterLocaleInput.value = 'en-US';
          }

          if (applyBtn) applyBtn.disabled = false;

          if (typeof this.hidePanel === 'function') this.hidePanel();
          return;
        }

        const formLocale = form.querySelector('input[name="locale_code"]');
        if (formLocale) formLocale.value = value;

        markSelected();
        updateLanguageButtonUI();

        if (applyBtn) {
          const hasCountry = !!form.querySelector('input[name="country_code"]')?.value;
          const hasLocale = !!form.querySelector('input[name="locale_code"]')?.value;
          applyBtn.disabled = !(hasCountry && hasLocale);
        }

        if (typeof this.hidePanel === 'function') this.hidePanel();
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        if (!this.elements.search) return;

        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = 0;

        if (this.elements.resetButton) {
          this.elements.resetButton.classList.toggle('hidden', !searchValue);
        }

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', !!searchValue);
        }

        allCountries.forEach((item) => {
          const countryEl = item.querySelector('.country');
          const countryName = countryEl ? this.normalizeString(countryEl.textContent) : '';

          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
          }
        });

        if (this.elements.liveRegion && window.accessibilityStrings?.countrySelectorSearchCount) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        const selector = this.querySelector('.country-selector');
        const list = this.querySelector('.country-selector__list');
        if (selector) selector.scrollTop = 0;
        if (list) list.scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        if (!this.elements.search) return;
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        if (this.elements.searchIcon) {
          this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
        }
      }

      onSearchBlur() {
        if (this.elements.searchIcon && this.elements.search && !this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
